import { render, staticRenderFns } from "./PreviewImg.vue?vue&type=template&id=f67034f4&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=js"
export * from "./PreviewImg.vue?vue&type=script&lang=js"
import style0 from "./PreviewImg.vue?vue&type=style&index=0&id=f67034f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67034f4",
  null
  
)

export default component.exports